import React from 'react';

function ProfileImage({ src, alt, initials, onClick }) {
  return (
    <div className="profile-image" onClick={onClick}>
      {src ? (
        <img src={src} alt={alt} />
      ) : (
        <div className="initials">{initials}</div>
      )}
    </div>
  );
}

export default ProfileImage;